// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:960px){.home-wrap[data-v-1d1b0b5c]{width:100%}}[data-v-1d1b0b5c] .loading-bg{min-width:50px;min-height:50px}", ""]);
// Exports
module.exports = exports;
